// Public attribution slug that MUST be present on every open_trade message
// sent from this platform. Trades missing this lose revenue/referral
// attribution on-chain, so it is enforced at the transaction chokepoints
// (executeEvmPerps / executePerps) rather than relying on each caller.
export const CLIENT_ORIGIN = "coded_estate";

// Guarantees `client_origin` is stamped on any open_trade message, regardless
// of where or how the message was constructed. Mutates in place and returns the
// message. No-op for non-open_trade messages (close/update/leverage/etc.), so
// it is safe to call in the generic execute paths.
export function enforceClientOrigin(message) {
  if (message && typeof message === "object" && message.open_trade) {
    message.open_trade.client_origin = CLIENT_ORIGIN;
  }
  return message;
}
